import React, {useState, useEffect, useContext, lazy} from 'react';

import {LPHandlerContext} from "../context/LPHandlerProvider"

const TempTest = lazy(() => import('./Temp_Test/Index'));
const Userlogin = lazy(() => import('./Comman/Userlogin'));
const Notfound = lazy(() => import('./Comman/Notfound'));
const ContactCard = lazy(() => import('./Comman/ContactCard'));
const TempBasic = lazy(() => import('./Temp_Basic/Main'));
const TempDoctor = lazy(() => import('./Temp_Doctor/Main'));
const DefaultTemplate = lazy(() => import('./Default_Template/Main'));
const LandingPageTemplate = lazy(() => import('./Landing_Page_Template/Main'));
const NewTemplate = lazy(() => import('./New_Template/Main'));

const TempSelector = props => {
	
    const lpvals = useContext(LPHandlerContext);
	
    const [template, setTemplate] = useState();
	
	//console.log('working cache now');
	//console.log(lpvals);
	
    useEffect(() => {
        if(lpvals.temp_name !== undefined && lpvals.temp_name !=="") {
			//console.log(lpvals.temp_name);
			
			//console.log(lpvals);
			
            let temp = null;
            if (lpvals.temp_name === 'Login') {
                temp = <Userlogin temp_name={lpvals.temp_name}/>;
            } else if (lpvals.temp_name === 'Contact_Card') {
                temp = <ContactCard temp_name={lpvals.temp_name} client_id={lpvals.client_id} lp_id={lpvals.lp_id}/>;
            } else if (lpvals.temp_name === 'Temp_Test') {
                temp = <TempTest temp_name={lpvals.temp_name}/>;
            } else if (lpvals.temp_name === 'Temp_Basic') {
                temp = <TempBasic temp_name={lpvals.temp_name} widget_temps={lpvals.widget_temps} />;
            } else if (lpvals.temp_name === 'Temp_Doctor') {
                temp = <TempDoctor temp_name={lpvals.temp_name} widget_temps={lpvals.widget_temps} />;
            } else if (lpvals.temp_name === 'Default_Template') {
                temp = <DefaultTemplate temp_name={lpvals.temp_name} widget_temps={lpvals.widget_temps} />;
            } else if (lpvals.temp_name === 'Landing_Page_Template') {
                temp = <LandingPageTemplate temp_name={lpvals.temp_name} widget_temps={lpvals.widget_temps} />;
            } else if (lpvals.temp_name === 'New_Template') {
                temp = <NewTemplate temp_name={lpvals.temp_name} widget_temps={lpvals.widget_temps} />;
            } else {
                temp = <Notfound temp_name={lpvals.temp_name}/>;
            }
            setTemplate(temp)
        }
    }, [lpvals]);

    return (
        <>
			{template}
        </>
    );
}

export default TempSelector;